/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Objevte všechny naše značky`
};

const da_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Opdag alle vores mærker`
};

const de_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Entdecken Sie alle unsere Marken`
};

const en_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Discover all our brands`
};

const es_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Descubre todas nuestras marcas`
};

const fr_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Découvrir toutes nos marques`
};

const hu_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Fedezd fel összes márkánkat`
};

const it_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Scopri tutte le nostre marche`
};

const nl_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Ontdek al onze merken`
};

const pl_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Odkryj wszystkie nasze marki`
};

const pt_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Descubra todas as nossas marcas`
};

const sv_discover_all_our_brands = /** @type {(inputs: {}) => string} */ () => {
	return `Upptäck alla våra varumärken`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const discover_all_our_brands = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discover_all_our_brands(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discover_all_our_brands", locale)
	if (locale === "cs") return cs_discover_all_our_brands(inputs)
	if (locale === "da") return da_discover_all_our_brands(inputs)
	if (locale === "de") return de_discover_all_our_brands(inputs)
	if (locale === "en") return en_discover_all_our_brands(inputs)
	if (locale === "es") return es_discover_all_our_brands(inputs)
	if (locale === "fr") return fr_discover_all_our_brands(inputs)
	if (locale === "hu") return hu_discover_all_our_brands(inputs)
	if (locale === "it") return it_discover_all_our_brands(inputs)
	if (locale === "nl") return nl_discover_all_our_brands(inputs)
	if (locale === "pl") return pl_discover_all_our_brands(inputs)
	if (locale === "pt") return pt_discover_all_our_brands(inputs)
	return sv_discover_all_our_brands(inputs)
};